import { ReactNode, CSSProperties } from 'react';

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: ReactNode;
  action?: ReactNode;
  style?: CSSProperties;
}

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  action,
  style,
}: SectionHeaderProps) {
  return (
    <div className="acc-section-header" style={style}>
      <div className="acc-section-header__content">
        {eyebrow && <div className="acc-section-header__eyebrow">{eyebrow}</div>}
        <h2 className="acc-section-header__title">{title}</h2>
        {subtitle && <div className="acc-section-header__subtitle">{subtitle}</div>}
      </div>
      {action && <div className="acc-section-header__action">{action}</div>}
    </div>
  );
}
